// Imported, so the EaterAccounts chunk downloads once login is opened.
export function openEaterLogin() {
    return import(
    /* webpackChunkName: "EaterAccounts" */ "../components/EaterAuthWrapper").then((mod) => mod.default.open());
}
export function eaterLoginPaths() {
    const config = Skubacz.configuration;
    return {
        account: config.account_path,
        terms: config.terms_path,
        privacyPolicy: config.privacy_policy_path,
    };
}
export function goToEaterAccount() {
    location.assign(Skubacz.configuration.account_path);
}
